import { Component } from '@angular/core';

@Component({
  selector: 'app-radni-zadatak',
  templateUrl: './radni-zadatak.component.html',
  styleUrls: ['./radni-zadatak.component.scss']
})
export class RadniZadatakComponent {}
